<template>
  <Form :title="title" :description="description" :handleNext="incrementIndex" :isDisabled="!lastName || !firstName">
    <InputField
      label="LastName"
      placeholder="You"
      :value="lastName"
      isRequired
      @input="$event => setLastName($event.target.value)"
    />
    <InputField
      label="FirstName"
      placeholder="Evan"
      :value="firstName"
      isRequired
      @input="$event => setFirstName($event.target.value)"
    />
  </Form>
</template>

<script>
import Form from '@/components/Form';
import InputField from '@/components/InputField';
import useIndex from '@/composition/useIndex';
import useField from '@/composition/useField';

export default {
  name: 'IdentityForm',
  components: {
    Form,
    InputField
  },
  props: {
    title: String,
    description: String
  },
  setup() {
    const { incrementIndex } = useIndex();
    const [lastName, setLastName] = useField('lastName');
    const [firstName, setFirstName] = useField('firstName');

    return {
      incrementIndex,
      lastName,
      setLastName,
      firstName,
      setFirstName
    };
  }
};
</script>
